import { appendEnvVars } from '@cli-utils/files.js'

export function persistBlobReadWriteToken(cwd: string, token: string): void {
  appendEnvVars(
    cwd,
    [
      {
        header: 'Storage (Vercel Blob)',
        vars: [{ key: 'BLOB_READ_WRITE_TOKEN', value: token }]
      }
    ],
    new Set(['BLOB_READ_WRITE_TOKEN'])
  )
}
